if not window.gs?
  window.gs = {}

gs = window.gs


#============================ Dirty Flag ==================================

class ManualDirtyFlag
  constructor:(observables...) ->
    @isDirty = ko.observable false
    @callbacks = []
    @modifying = false

    for value in observables
      value.subscribe => @setDirty()

  addObservables:(observables...) ->
    for value in observables
      value.subscribe => @setDirty()

  setDirty:() ->
    return if @modifying
    return if @isDirty()
    @isDirty true
    for callback in @callbacks
      callback()

  addCallback:(callback) ->
    @callbacks.push(callback)

  setModifying: ()->
    @modifying = true

  reset: () ->
    @isDirty false
    @modifying = false

gs.ManualDirtyFlag = ManualDirtyFlag

ko.bindingHandlers.toggleClick = init: (element, valueAccessor) ->
  value = valueAccessor()
  ko.utils.registerEventHandler element, "click", ->
    value not value()
    return

  return

#============================ Authentication ==================================
class Authentication
  constructor: () ->
    @logged_in = ko.observable false

    @username = ko.observable ""
    @first = ko.observable ""
    @last = ko.observable ""
    @email = ko.observable ""
    @session_key = ""

    @username_attempt = ko.observable ""
    @password_attempt = ko.observable ""
    @password_new = ko.observable ""
    @password_newb = ko.observable ""

    @state = ko.observable ""
    @message = ko.observable "Enter Username and Password"

    @next_url = ko.observable null

    @user_dirty = new gs.ManualDirtyFlag(@username, @first, @last, @email)
    @pass_dirty = new gs.ManualDirtyFlag(@password_new, @password_newb)

    @pass_change_working = ko.observable false
    @pass_change_message = ko.observable ""
    @pass_change_status = ko.observable ""

    @name = ko.computed =>
      if @logged_in()
        if @first() or @last()
          "#{@first()} #{@last()}"
        else
          @username()
      else
        "Not logged in!"

  apply_data: (data) =>
    gs.bindings.apply_login_data(data)

    user = data["user_data"]
    if user?
      @username user['username']
      @username_attempt user['username']
      @first user['first']
      @last user['last']
      @email user['email']

      @logged_in user['username']?

      new_session = user['session']
      if new_session != @session_key
        gs.live_data?.set_session new_session
        @session_key = new_session

      # Remove stale Login please messages
      gs.bindings.clear_messages "login"

      # If we are now logged in
      if @next_url()?
        gs.router.navigate(@next_url())
        @next_url null
      else if user['username']? and gs.bindings.mode() == "Login Form"
        gs.router.navigate(gs.bindings.root_url)

      @user_dirty.reset()


  get_auth: (done_func) =>
    gs.show_loading("auth")
    url = "#{dynamic_hostname}auth.json"
    $.ajax
      url: url
      dataType: 'json'
      success: (data, textStatus, jqXHR) =>
        console?.log "Login data recieved:", textStatus, data
        @apply_data data
        gs.done_loading("auth")
        done_func?()

      error: (jqXHR, textStatus, errorThrown) =>
        console?.log "Login data error:", textStatus, errorThrown
        @state "fail"
        @message "Could not login due to server error. Please try later."
        gs.done_loading("auth")
        done_func?()

    @password_attempt ""

  send_login: () =>
    @state "attempt"
    @message "Logging in, please wait"

    url = "#{dynamic_hostname}auth.json"
    gs.show_loading("login")
    $.ajax
      url: url
      type: 'POST'
      data:
        user: @username_attempt()
        pass: @password_attempt()
      dataType: 'json'
      success: (data, textStatus, jqXHR) =>
        if data.login?.error?
          # need to flash an error here.
          console?.log "Login Failed: ", data.login.error
          @state "fail"
          @message data.login.error
          gs.done_loading("login")
        else
          gs.bindings.clear_messages "login"

          #console?.log "Login Success:", textStatus, data
          @apply_data data
          @state "success"
          @message "Welcome back #{@name()}"

          gs.bindings.show_message "Logged in", @message(), "success", "login"
          gs.done_loading("login")

        @state ""
        @password_attempt ""

      error: (jqXHR, textStatus, errorThrown) =>
        console?.log "Error from server for Login:", textStatus, errorThrown
        @state "fail"
        @message "Server Error, try logging in here: https://gridspy.com/d/accounts/login/."
        @password_attempt ""

    return null # Prevent any calling forms from submitting

  send_logout: () =>
    @state "attempt"
    @message "Logging out"

    gs.show_loading("login")
    url = "#{dynamic_hostname}auth.json"
    $.ajax
      url: url
      type: 'POST'
      data:
        logout: true
      dataType: 'json'
      success: (data, textStatus, jqXHR) =>
        #console?.log "Logged out successfully", textStatus, data
        gs.bindings.clear_messages "login"

        @state ""
        @message "Signed Out Successfully. Log back in?"
        gs.router.navigate "#list"
        @apply_data data

        gs.bindings.clear_messages "login"
        gs.bindings.show_message "Logged out.", "Please come back soon", "info", "login"
        gs.done_loading("login")

      error: (jqXHR, textStatus, errorThrown) =>
        console?.log "Log-out failed", textStatus, errorThrown

        gs.bindings.show_message "Can't leave?", @message(), "error"
        gs.done_loading("login")

    return true

  send_profile_change: () =>
    url = "#{dynamic_hostname}api/dev/profile"
    $.ajax
      url: url
      type: 'PATCH'
      data:
        username: @username()
        first_name: @first()
        last_name: @last()
        email: @email()
      dataType: 'json'
      success: (data, textStatus, jqXHR) =>
        console?.log "User Details changed successfully", textStatus, data
        #@pass_change_message "Password changed successfully"
        #@pass_change_status "success"
        @user_dirty.reset()

      error: (jqXHR, textStatus, errorThrown) =>
        console?.log "User Details change failed", textStatus, errorThrown

  send_password_change: () =>
    @pass_change_message "Changing Password"
    @pass_change_status "attempt"
    url = "#{dynamic_hostname}auth.json"
    $.ajax
      url: url
      type: 'POST'
      data:
        user: @username_attempt()
        pass: @password_attempt()
        pass_new: @password_new()
      dataType: 'json'
      success: (data, textStatus, jqXHR) =>
        if data.login?.error?
          # need to flash an error here.
          console?.log "Login Failed: ", data.login.error
          @pass_change_status "fail"
          @pass_change_message data.login.error
        else
          console?.log "Password changed successfully", textStatus, data
          @pass_change_message "Password changed successfully"
          @pass_change_status "success"
          @password_attempt ""
          @password_new ""
          @password_newb ""
          @pass_dirty.reset()

      error: (jqXHR, textStatus, errorThrown) =>
        console?.log "Password change failed", textStatus, errorThrown
        @pass_change_message "Password change failed (server error)"
        @pass_change_status "fail"
        #@password_attempt ""
        #@password_new ""
        #@password_newb ""

    return null # Prevent any calling forms from submitting

  show_pw_change: () =>
    alert "Not Implimented"


#======================== View Model Support Classes =============================
class ModeOption
  constructor: (@name, @type, @icon, @on_enter, errors=0) ->
    @errors = ko.observable errors
    @root = undefined
    @active = ko.computed gs.common.defer => this.root != undefined and @ == this.root.curr_mode()
    @url = ko.computed gs.common.defer =>
      gs.bindings.url_for mode:@

  select: ->
    @root.set_mode @
    @on_enter()

  set_root: (root) ->
    @root = root

#============================ Basic View Model ==================================
class BaseViewModel
  constructor: (@view_modes, @root_url = "list") ->
    for mode in @view_modes
      mode.set_root(@)

    @fullscreen = ko.observable false
    @auth = new Authentication()

    @fullscreen_toggle = =>
      @fullscreen not @fullscreen()
      gs.wireup.fullscreen_toggle()
      gs.router.navigate @url_for({}, "")
      return false

    @modes_of_type = (type)=>
      for mode in @view_modes
        if mode.type != type
          continue
        else
          mode

    @curr_mode = ko.observable @view_modes[0]
    @mode = ko.computed => @curr_mode().name
    @mode_type = ko.computed => @curr_mode().type

    @page_heading = ko.computed =>
      "GridSpy"

    @page_h1 = ko.computed =>
      "Gridspy"

    @page_h2 = ko.computed =>
      null

  set_fullscreen: (val)->
    if val != @fullscreen()
      @fullscreen_toggle()

  apply_login_data: (data) ->
    # Nothing to do

  url_for: (values = {}, prefix = null)->
    mode = if values.mode? then values.mode else @curr_mode()

    if mode.name == "Profile"
      return "#profile"
    else if mode.name == "Login Form"
      return "#login"
    else
      return ""

  update_url: (values = {}) ->
    # Calculate the current page URL and pass that onto sammy JS
    url = @url_for values, ""
    curr_loc = gs.router.getHash()
    if curr_loc != url
      gs.router.navigate(url)

  set_mode: (mode) ->
    return false unless mode?

    if typeof(mode) == "string"
      name = mode
      mode = null
      for a_mode in @view_modes
        if a_mode.name == name
          mode = a_mode
          break

      return false unless mode?

    if @curr_mode() != mode
      console?.log "Changed mode to:", mode
      @curr_mode mode
      mode.select()

    return true

  show_message: (head, msg, type, id = "") ->
    # Valid Types : "" (warn), "error", "success", "info"
    head = head or ""
    msg = msg or ""
    type = type or ""

    console?.log "show_message", head, msg, type

    if type != ""
      type = "alert-#{type}"

    $("#alerts").append """<div class="alert #{type} msg_#{id} fade in" data-alert="alert">
        <button type="button" class="close" data-dismiss="alert">&times;</button>
        <strong>#{head}</strong> #{msg}
        </div>"""

  clear_messages: (id) ->
    alerts = if id?
        $("#alerts .alert.msg_#{id}")
      else
        $("#alerts .alert")

    try
      alerts.alert('close')
    catch ex
      try
        alerts.remove()
      catch ex2
        console?.log "Exception clearing message #{id}."

  login_first: (reason) ->
    @auth.next_url gs.router.getHash()
    gs.router.navigate "#login"
    #@set_mode "Login Form"
    @clear_messages "login"
    @show_message "Please Login", reason, "info", "login"

gs.BaseViewModel = BaseViewModel
gs.ModeOption = ModeOption

# ============================== Util code to run on every dynamic page
# Load the CRSF Cookie and put that into all AJAX headers sent from this page.

csrftoken = $.cookie('csrftoken')
$.ajaxPrefilter ( options, originalOptions, jqXHR ) ->
  #Modify options, control originalOptions, store jqXHR, etc
    if ( !options.beforeSend)
      if options.url.indexOf('/api/') >= 0 or options.url.indexOf('/d/') >= 0
        # API Calls require the CSRF token.
        options.beforeSend = (xhr) ->
            xhr.setRequestHeader('X-CSRFToken', csrftoken)
